export default class NodeMap {
  constructor() {
    this.clear();
  }

  set(node, value) {
    this.nodes[node.id] = value;
  }

  get(node) {
    return this.nodes[node.id];
  }

  remove(node) {
    if (!this.has(node)) return false;
    delete this.nodes[node.id];
    return true;
  }

  has(node) {
    return this.nodes[node.id] !== undefined;
  }

  clear() {
    this.nodes = {};
  }

  size() {
    return Object.keys(this.nodes).length;
  }

  forEach(fn) {
    Object.keys(this.nodes).forEach(id => {
      fn(this.nodes[id], id);
    });
  }

  merge(other) {
    other.forEach((value, id) => { this.nodes[id] = value; });
  }
}
